import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { GanttElemento, GanttElementoCreate } from "@/types/api";

/** Invalida sia la lista admin sia il Gantt che vede il cliente. */
function useInvalida() {
  const qc = useQueryClient();
  return () => {
    qc.invalidateQueries({ queryKey: ["admin-gantt"] });
    qc.invalidateQueries({ queryKey: ["gantt"] });
  };
}

export function useAdminGantt() {
  return useQuery({
    queryKey: ["admin-gantt"],
    queryFn: () => apiFetch<GanttElemento[]>("/api/v1/admin/gantt"),
    staleTime: 15_000,
  });
}

export function useCreaElementoGantt() {
  const invalida = useInvalida();
  return useMutation({
    mutationFn: (body: GanttElementoCreate) =>
      apiFetch<GanttElemento>("/api/v1/admin/gantt", {
        method: "POST",
        body: JSON.stringify(body),
      }),
    onSuccess: invalida,
  });
}

export function useAggiornaElementoGantt() {
  const invalida = useInvalida();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: Partial<GanttElementoCreate> }) =>
      apiFetch<GanttElemento>(`/api/v1/admin/gantt/${id}`, {
        method: "PATCH",
        body: JSON.stringify(body),
      }),
    onSuccess: invalida,
  });
}

export function useEliminaElementoGantt() {
  const invalida = useInvalida();
  return useMutation({
    mutationFn: (id: string) =>
      apiFetch<void>(`/api/v1/admin/gantt/${id}`, { method: "DELETE" }),
    onSuccess: invalida,
  });
}
